(() => {
  const HEADING = 'Materials & Details';
  const CARE_HEADING = 'Care Instructions';
  const CARE_ITEMS = [
    'Avoid direct contact with perfume, lotion, hairspray, and household chemicals.',
    'Remove before swimming, bathing, exercising, or sleeping.',
    'Wipe gently with a soft, dry cloth after wear.',
    'Store separately in a dry pouch or jewelry box.',
  ];

  const createAccordion = (title, className) => {
    const details = document.createElement('details');
    details.className = `dv-product-accordion ${className}`;

    const summary = document.createElement('summary');
    summary.className = 'dv-product-accordion__summary';

    const heading = document.createElement('h3');
    heading.textContent = title;

    const content = document.createElement('div');
    content.className = 'dv-product-accordion__content';

    summary.append(heading);
    details.append(summary, content);

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      details.open = !details.open;
    });

    return { details, summary, heading, content };
  };

  const enhanceMaterialsDetails = (root = document) => {
    root.querySelectorAll('rte-formatter h3').forEach((heading) => {
      if (heading.textContent.trim() !== HEADING || heading.closest('.dv-materials-details')) return;

      const { details, summary, content } = createAccordion(HEADING, 'dv-materials-details');

      heading.before(details);
      summary.replaceChildren(heading);

      while (details.nextSibling) content.append(details.nextSibling);

      const care = createAccordion(CARE_HEADING, 'dv-care-instructions');
      const careList = document.createElement('ul');
      CARE_ITEMS.forEach((instruction) => {
        const item = document.createElement('li');
        item.textContent = instruction;
        careList.append(item);
      });
      care.content.append(careList);
      details.after(care.details);
    });
  };

  const style = document.createElement('style');
  style.textContent = `
    .dv-product-accordion {
      border-block: 1px solid rgb(var(--color-border-rgb) / 0.6);
      margin-block-start: 1.5rem;
      position: relative;
    }

    .dv-product-accordion + .dv-product-accordion {
      border-block-start: 0;
      margin-block-start: 0;
      z-index: 1;
    }

    .dv-product-accordion__summary {
      align-items: center;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      list-style: none;
      padding-block: 1rem;
    }

    .dv-product-accordion__summary::-webkit-details-marker {
      display: none;
    }

    .dv-product-accordion__summary::after {
      content: '+';
      flex: 0 0 auto;
      font-size: 1.5rem;
      font-weight: 400;
      line-height: 1;
      margin-inline-start: 1rem;
    }

    .dv-product-accordion[open] > .dv-product-accordion__summary::after {
      content: '−';
    }

    .dv-product-accordion__summary h3 {
      margin: 0;
    }

    .dv-product-accordion__content {
      padding-block-end: 1rem;
    }

    .dv-product-accordion__content > :first-child {
      margin-block-start: 0;
    }
  `;
  document.head.append(style);

  enhanceMaterialsDetails();

  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) enhanceMaterialsDetails(node);
      });
    });
  }).observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });
})();
